import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PubComponent } from '../published-lionscript/pub-component';
import { IoniScriptManager } from '../engine/io-manager';
import { PubComponentListener } from '../published-lionscript/pub-component-listener';
import { LionEngine } from '../engine/io-engine';

@Component({
    selector: 'simple-file-upload',
    templateUrl: './simple-file-upload.component.html',
    styleUrls: ['./simple-file-upload.component.css']
})


export class SimpleFileDropComponent implements OnInit, OnChanges, PubComponent {
    selectedFile: File | null = null;
    selectedFileName: string | null = null;

    constructor(private http: HttpClient) { }
    data: any;
    listener: PubComponentListener;
    resolveFunction: any;
    title: string;
    fileFunction;
    // Set only when the panel that opened this said what leaving means. Without it there
    // is no Cancel, because a Cancel that does nothing is worse than no Cancel at all.
    cancelFunction;
    showCancel = false;


    init(ionEngine: IoniScriptManager): string {


        return '';

    }
    ngOnChanges(changes: SimpleChanges): void {

    }
    ngOnInit(): void {


        if (this.data != null) {
            if (this.data['fileFunction']) {
                this.fileFunction = LionEngine.ionfunctions[this.data['fileFunction']]
            }
            if (this.data['cancelFunction']) {
                this.cancelFunction = LionEngine.ionfunctions[this.data['cancelFunction']]
                this.showCancel = !!this.cancelFunction;
            }
        }
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            this.selectedFile = input.files[0];
            this.selectedFileName = this.selectedFile.name;
        }
    }

    onCancel(): void {
        if (this.cancelFunction) {
            this.cancelFunction();
        }
    }

    onUpload(): void {
        if (!this.selectedFile) {
            // The button is disabled until a file is chosen, so this is a guard rather
            // than a message anyone should ever see.
            return;
        }


        if ( this.fileFunction ) {
            this.fileFunction ( this.selectedFile )
        }

        // const formData = new FormData();
        // formData.append('file', this.selectedFile);

    }
}
